/**
 * The Sentry DSN, in a module of its own so that things which only need to derive a
 * URL from it do not have to pull in the Sentry SDK.
 *
 * The CSP `report-uri` in `nginx.conf` and `public/_headers` is one such thing. Both
 * are static text that cannot import TypeScript, so each hardcodes the endpoint and
 * `deployHeaders.test.ts` derives the expected value from here — the same trick that
 * file already uses to keep `connect-src` honest against `PRODUCTION_APP_CONFIG`.
 *
 * Not a secret. A DSN's public key authorizes writing events to this project and
 * nothing else, which is why it ships in the client bundle already.
 */
export const SENTRY_DSN =
	"https://c315fccc4e82de9d2750b4faa7592c7c@o4510703071854592.ingest.us.sentry.io/4510703116025857";

/**
 * Where a CSP `report-uri` directive should post violation reports.
 *
 * `report-uri` rather than the newer `report-to`, despite the deprecation: Sentry's
 * security endpoint parses the single `{"csp-report": …}` body that `report-uri`
 * sends, not the Reporting API's batched envelope, and `report-uri` is the only one
 * of the two that Firefox and Safari implement. Chrome honours it whenever no
 * `report-to` is present.
 *
 * Reports are exempt from `connect-src`, so the endpoint needs no CSP allowance of
 * its own — though this origin happens to be in `connect-src` already, for the SDK.
 */
export function cspReportUri(environment: string, dsn = SENTRY_DSN): string {
	const { username: publicKey, host, pathname } = new URL(dsn);
	const projectId = pathname.slice(1);
	if (!publicKey || !projectId) {
		throw new Error(`Malformed Sentry DSN: ${dsn}`);
	}
	return `https://${host}/api/${projectId}/security/?sentry_key=${publicKey}&sentry_environment=${environment}`;
}
